export const decodePaymentToken = (token) => {
  try {
    const payload = token.split('.')[1];
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
};

// Returns the post-payment redirect path. Prefers redirectTo embedded in the
// token (set when payment is initiated from a specific page), then falls back
// to the module-level default.
export const resolveRedirectPath = (decoded, moduleConfig) => {
  const raw = decoded?.redirectTo;
  const safe = typeof raw === 'string' && raw.startsWith('/') ? raw : null;
  return safe ?? moduleConfig?.redirectPath ?? DEFAULT_REDIRECT_PATH;
};

// Add new modules here as payments expand to other areas
export const PAYMENT_MODULE_CONFIG = {
  CHARGER_LICENSE: {
    label: 'Charger License',
    successMessage: 'Your charger licenses have been purchased successfully.',
    renewalMessage: 'Your charger licenses have been renewed successfully.',
    redirectPath: '/charger',
    redirectLabel: 'Go to Chargers',
  },
  FLEET_WALLET: {
    label: 'Fleet Wallet',
    successMessage: 'Your fleet wallet has been topped up successfully.',
    redirectPath: '/fleet/operators',
    redirectLabel: 'Go to Fleet',
  },
};

export const PAYMENT_FAILURE_REASONS = {
  order_mismatch:  'Payment verification failed due to an order mismatch. Please contact support.',
  payment_failed:  'Your payment was not completed. Please try again.',
  invalid_token:   'Your payment session is invalid or has expired.',
  order_not_found: 'Order details could not be found. Please contact support.',
  server_error:    'An unexpected error occurred while processing your payment. Please contact support.',
};

export const DEFAULT_REDIRECT_PATH = '/dashboard';
